export default "__VITE_ASSET__C9WsJ$Ck__"